// Generated by CoffeeScript 2.7.0
var Scrollback;

Scrollback = class Scrollback {
  constructor(element1) {
    this.backToBottom = this.backToBottom.bind(this);
    this.element = element1;
    this.bindEvents();
    this.scrollInstance = document.body.clientHeight;
  }

  bindEvents() {
    return this.element.addEventListener("click", this.backToBottom, false);
  }

  unbindEvents() {
    return this.element.removeEventListener("click", this.backToBottom, false);
  }

  backToBottom() {
    return window.scrollTo({
      top: this.scrollInstance,
      behavior: "smooth"
    });
  }

};

Vue.directive('scrollback', {
  bind: function(element) {
    if (Skylark.Helpers.Utilities.checkBrowser('IOS')) {
      return element.scrollback = new Scrollback(element);
    }
  },
  unbind: function(element) {
    if (element.scrollback) {
      element.scrollback.unbindEvents();
      return delete element.scrollback;
    }
  }
});
